import actionCreatorFactory from "typescript-fsa";
import { CouponCheckRequestBody } from "../../core/api/requests/coupon/check/types";
import { OrderFinalizeRequestBody } from "../../core/api/requests/order/finalize/types";
import { OrderSearchRequestBody } from "../../core/api/requests/order/search/types";
import { OrderStatusRequestBody } from "../../core/api/requests/order/status/types";
import { OrderTemporaryRequestBody } from "../../core/api/requests/order/temporary/types";
import { CommonAsyncType } from "../../core/types";
import { OrderContent, OrderHistory } from "./types";

const actionCreator = actionCreatorFactory("@@Order");

export const orderActions = {
  getOrderId: actionCreator.async<CommonAsyncType<{ orderId: string }> & OrderTemporaryRequestBody, {}>("GET_ORDER_ID"),
  checkOrderItems: actionCreator.async<CommonAsyncType & CouponCheckRequestBody, OrderContent>("CHECK_ORDER_ITEMS"),
  clearOrderItems: actionCreator("CLEAR_ORDER_ITEMS"),
  updateOrderStatus: actionCreator.async<CommonAsyncType & OrderStatusRequestBody, {}>("UPDATE_ORDER_STATUS"),
  createOrder: actionCreator.async<CommonAsyncType & OrderFinalizeRequestBody, {}>("CREATE_ORDER"),
  getOrderHistory: actionCreator.async<CommonAsyncType & OrderSearchRequestBody, OrderHistory[]>("GET_ORDER_HISTORY"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
